'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

require('./constants-0cf35288.js');
var React = require('react');
var React__default = _interopDefault(React);
require('./enums-de2d9d36.js');
var useOnClickOutside_hook = require('./use-on-click-outside.hook-fa9c21ca.js');
var drawerSection = require('./drawer-section-2084bccb.js');

var Drawer = function (_a) {
    var className = _a.className, children = _a.children, open = _a.open, anchor = _a.anchor, dataCy = _a.dataCy, handleClose = _a.onClose;
    var sectionRef = React.useRef(null);
    useOnClickOutside_hook.useOnClickOutside(function () { return open && handleClose(); }, [sectionRef]);
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(drawerSection.DrawerBackground, { open: open }),
        React__default.createElement(drawerSection.DrawerSection, { className: className, ref: sectionRef, open: open, anchor: anchor, "data-cy": dataCy },
            React__default.createElement(drawerSection.CloseButton, { onClick: handleClose, anchor: anchor, role: "button" }),
            children)));
};

exports.Drawer = Drawer;
